var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0811 24.8986L12.7914 25.6155L13.5018 24.8986L31.7103 6.52196L32.4078 5.81811L31.7103 5.11425L29.2625 2.64381L28.5521 1.9269L27.8418 2.64381L12.7914 17.8331L6.1582 11.1387L5.44785 10.4218L4.73751 11.1387L2.28965 13.6091L1.59224 14.313L2.28965 15.0168L12.0811 24.8986Z",
    fill: "#4BB71A",
    stroke: "#4BB71A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGreen);
export default __webpack_public_path__ + "static/media/rightGreen.1ffb6eb9a246b7d732d3171e2d1f43a5.svg";
export { ForwardRef as ReactComponent };